module.exports = __webpack_public_path__ + "static/img/企业联谊@2x (1).7c7859a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/企业联谊@2x (1).png
// module id = dUzm
// module chunks = 1